<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view/>
    </div>
  </a-config-provider>
</template>
<script>
  import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
  import enquireScreen from '@/utils/device'

  export default {
    data () {
      return {
        locale: zhCN,
      }
    },
    created () {
      let that = this
      enquireScreen(deviceType => {
        // update-begin-author:jeayea date:20260831 for:窄屏下内容区被常驻侧边栏挤窄、查询区不再自适应
        // 窄屏档(768~1088px)：保持桌面布局，只把左侧菜单折叠成图标条，菜单不会消失，
        // 同时把 120px 宽度让回内容区，查询表单和表格仍按响应式栅格自适应。
        if (deviceType === 0) {
          that.$store.commit('TOGGLE_DEVICE', 'desktop')
          that.$store.dispatch('setSidebar', false)
        }
        // update-end-author:jeayea date:20260831 for:窄屏下内容区被常驻侧边栏挤窄、查询区不再自适应
        // mobile
        else if (deviceType === 1) {
          that.$store.commit('TOGGLE_DEVICE', 'mobile')
          that.$store.dispatch('setSidebar', false)
        }
        else {
          that.$store.commit('TOGGLE_DEVICE', 'desktop')
          that.$store.dispatch('setSidebar', true)
        }

      })
    }
  }
</script>
<style>
  #app {
    height: 100%;
  }
</style>